import { render, staticRenderFns, recyclableRender, components } from "./search.vue?vue&type=template&id=02c50e3b&scoped=true&"
var renderjs
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"
import style0 from "./search.vue?vue&type=style&index=0&id=02c50e3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!C:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c50e3b",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/item/search.vue"
export default component.exports